import React, { useState, useRef } from "react";
import ActionBar from "../../common/ActionBar";
import {
  Grid,
  FormControlLabel,
  RadioGroup,
  Radio,
  makeStyles,
  AppBar,
  Tabs,
  Tab,
} from "@material-ui/core";
import { Formik } from "formik";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import {
  StyledFormElementsWrapper,
  Container,
  FormLabel,
} from "../NoticeGeneration/styles";
import FormField from "../../common/FormField/FormField";
import { PrimaryCTAButton } from "../../common/Buttons";
import { s3Upload } from "../../common/FileUploadS3";
import { CustomFileUpload } from "../../common/FormInputs";
import { getFileName } from "../../../helpers/functions";
import useLoader from "../../../hooks/useLoader";
import { arbitratorValidationSchema } from "../../../helpers/validationSchema";
import ArbitratorMeeting from "./component/ArbitratorMeeting";
import ArbitratorRecordings from "./component/ArbitratorRecordings";
import styled from "styled-components";
import PropTypes from "prop-types";
import MeetingService from "../../../services/MeetingService";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <StyledText style={{ height: "100%" }}>{children}</StyledText>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const StyledText = styled.article`
  font-family: ${theme.fonts.primaryFontBold};
  color: ${COLORS.COLOR_DARK};
  overflow: auto;
`;

const useStyles = makeStyles((themes) => ({
  formLabel: {
    fontFamily: theme.fonts.primaryFontSemiBold,
    color: COLORS.COLOR_DARK,
  },
  root: {
    margin: 15,
    [themes.breakpoints.up(640)]: {
      margin: "0px 46px",
    },
    "& .MuiTab-root": {
      padding: "5px 0",
      [themes.breakpoints.up(640)]: {
        padding: "6px 12px",
      },
    },
    "& .MuiTab-wrapper": {
      fontSize: 12,
      [themes.breakpoints.up(640)]: {
        fontSize: 16,
      },
    },
  },

  radioRoot: {
    margin: 15,
    [themes.breakpoints.up(640)]: {
      margin: "0px 26px",
    },
    "& .MuiTab-root": {
      padding: "5px 0",
      [themes.breakpoints.up(640)]: {
        padding: "6px 12px",
      },
    },
    "& .MuiTab-wrapper": {
      fontSize: 12,
      [themes.breakpoints.up(640)]: {
        fontSize: 16,
      },
    },
  },

  appBar: {
    color: COLORS.COLOR_DARK,
    boxShadow: "none",
    background: "transparent",
    fontFamily: theme.fonts.primaryFontBold,
    "& .MuiTabs-flexContainer": {
      justifyContent: "space-between",
      [themes.breakpoints.up(640)]: {
        justifyContent: "flex-start",
      },
    },
  },

  label: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 80,
    [themes.breakpoints.up(400)]: {
      width: "auto",
      maxWidth: 230,
    },
  },
}));

const radio_inputs = [
  {
    label: "On Single Meeting",
    name: "single",
    value: "single",
  },
  {
    label: "Bulk Meeting Creation",
    name: "bulk",
    value: "bulk",
  },
];

const inputs = [
  {
    name: "name",
    type: "text",
    label: "Arbitrator Name",
    required: true,
  },
  { name: "email", type: "email", label: "Arbitrator Email", required: true },
];

const upload_templates = [
  {
    name: "arbitratorExcel",
    label: "Upload Arbitrator Excel",
    type: "upload",
    required: true,
    accept: ".xlsx",
    types: [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
      "text/csv",
    ],
  },
];

const Index = () => {
  const classes = useStyles();
  const { setLoader } = useLoader();
  const MTRef = useRef();
  const [value, setValue] = useState(0);
  const { enqueueSnackbar } = useSnackbar();

  async function onFormSubmit(values, { resetForm }) {
    try {
      setLoader({ state: true, message: `creating meeting...` });
      let payload = {};
      if (values.meetingType === "single") {
        payload = {
          name: values.name,
          email: values.email,
        };
      } else {
        payload = {
          arbitratorExcel: values.arbitratorExcel,
        };
      }
      const response = await MeetingService.createMeetingUrlArb(payload);
      if (response?.message) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      resetForm();
      MTRef.current.onQueryChange(MTRef?.current?.state?.query);
    }
  }

  return (
    <React.Fragment>
      <ActionBar breadcrumbs={["Arbitrator Meeting Details"]} />
      <Formik
        initialValues={{
          meetingType: "single",
          name: "",
          email: "",
          page: "",
          tabType: "details",
          arbitratorExcel: "",
          meetingId: 1,
        }}
        enableReinitialize
        validateOnBlur
        validateOnChange
        validationSchema={arbitratorValidationSchema}
        onSubmit={onFormSubmit}
      >
        {({
          values,
          handleChange,
          errors,
          handleSubmit,
          touched,
          setFieldValue,
          setFieldError,
          handleBlur,
          isValid,
          resetForm,
        }) => (
          <form>
            <Grid
              className={classes.radioRoot}
              item
              xs={12}
              spacing={2}
              style={{ marginTop: "5px", padding: 16 }}
            >
              <RadioGroup
                style={{
                  flexDirection: "row",
                  marginLeft: "10px",
                }}
                name={"meetingType"}
                value={values.meetingType}
                onChange={(e) => {
                  setFieldValue("meetingType", e.target.value);
                  //   MTRef.current.onQueryChange(MTRef?.current?.state?.query);
                }}
              >
                {radio_inputs.map((radio, key) => (
                  <FormControlLabel
                    {...{ key }}
                    classes={{ label: classes.formLabel }}
                    value={radio.value}
                    control={
                      <Radio size="medium" style={{ color: "#00838c" }} />
                    }
                    label={radio.label}
                  />
                ))}
              </RadioGroup>
            </Grid>
            <Container>
              <StyledFormElementsWrapper width="70%">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                    gap: 18,
                  }}
                >
                  {values.meetingType === "single"
                    ? inputs.map((input, index) => {
                        return (
                          <FormField
                            key={index}
                            {...{
                              touched,
                              errors,
                              input,
                              values,
                              handleChange,
                              handleBlur,
                              setFieldValue,
                            }}
                          />
                        );
                      })
                    : upload_templates.map((upload, index) => (
                        <div style={{ marginTop: 10 }}>
                          <FormLabel>
                            {upload.label}{" "}
                            <span className="required-star"> *</span>
                          </FormLabel>
                          <CustomFileUpload
                            error={touched[upload.name] && errors[upload.name]}
                            setFile={(file) =>
                              s3Upload(
                                file,
                                upload.name,
                                setFieldValue,
                                upload.types,
                                setLoader,
                              )
                            }
                            style={{
                              width: "90%",
                              marginBottom: 15,
                            }}
                            accept={upload.accept}
                            file={{ name: getFileName(values[upload.name]) }}
                          />
                        </div>
                      ))}
                </div>

                <PrimaryCTAButton
                  style={{ marginTop: 15, width: "45%" }}
                  onClick={handleSubmit}
                >
                  Submit
                </PrimaryCTAButton>
              </StyledFormElementsWrapper>
            </Container>
            <div className="paymentHistory">
              <div className={classes.root}>
                <AppBar className={classes.appBar} position="static">
                  <Tabs
                    value={value}
                    indicatorColor="primary"
                    onChange={(_, newValue) => setValue(newValue)}
                    aria-label="pending-action-tab"
                  >
                    <Tab
                      label={
                        <div className={classes.label}>Meeting Details</div>
                      }
                      {...a11yProps(0)}
                    />
                    <Tab
                      label={<div className={classes.label}>Recordings</div>}
                      {...a11yProps(1)}
                    />
                  </Tabs>
                </AppBar>

                <TabPanel value={value} index={0}>
                  <ArbitratorMeeting
                    {...{ MTRef, setValue, setFieldValue }}
                    meetingId={values?.meetingId}
                    page={values.page}
                  />
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <ArbitratorRecordings
                    {...{ MTRef }}
                    meetingId={values?.meetingId}
                  />
                </TabPanel>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </React.Fragment>
  );
};

export default Index;
